import { renderStoryBlokRichText } from "apps/website/utils/storyblok/text";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import { IStoryBlokComponent } from "apps/website/components/page/api.types";

export interface IStoryBlokArticleRichText {
  content: string;
}

interface IStoryBlokArticleRichTextComponent extends IStoryBlokComponent<IStoryBlokArticleRichText> {
  isLede?: boolean;
}

// Lede: larger, bolder intro treatment for the first rich-text block (Figma:
// Greed Bold, 24px, tracking -0.48px, line-height 1.3). TextBody size 1 gives
// the 24px and tracking-tighter (-0.48px) already; override the paragraph
// resolver's `<p>` descendants for the display font and looser line-height.
const LEDE_CLASS_NAME = "[&_p]:font-display [&_p]:leading-looser";

// Even paragraph rhythm (Figma: a consistent 16px gap between paragraphs). The
// rich-text renderer emits each paragraph as a bare `<p>` with no margin, so
// multiple paragraphs inside one block used to run together. Give every
// top-level paragraph a 16px bottom margin; the last one stays flush so it does
// not double up with the block-level trailing Spacer below. Scoped to the
// article wrapper so `renderStoryBlokRichText` usage elsewhere is untouched.
const PARAGRAPH_SPACING_CLASS_NAME = "[&>p]:mb-4 [&>p:last-child]:mb-0";

export const StoryBlokArticleRichText = ({
  blok,
  isLede = false,
}: IStoryBlokArticleRichTextComponent) => (
  <>
    <TextBody
      tag="div"
      size={isLede ? 1 : 2}
      className={`${PARAGRAPH_SPACING_CLASS_NAME} ${isLede ? LEDE_CLASS_NAME : ""}`}
    >
      { renderStoryBlokRichText(blok.content, { variant: "article" }) }
    </TextBody>
    <Spacer size="xl" />
  </>
);
